/*
 * @Author: zhouhm 1148305943@qq.com
 * @Date: 2025-09-22 15:06:33
 * @LastEditors: zhouhm 1148305943@qq.com
 * @LastEditTime: 2025-09-22 15:47:48
 * @FilePath: \road_monitor_app\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import router from "./router";
import "lib-flexible/flexible";

// import VConsole from "vconsole";
// const vConsole = new VConsole();
// vConsole.destroy();

Vue.use(ElementUI);
// import VideoPlayer from 'vue-video-player'
// require('video.js/dist/video-js.css')
// require('vue-video-player/src/custom-theme.css')
// Vue.use(VideoPlayer)

import axios from "axios";
Vue.prototype.$axios = axios;
var interceptLogin = axios.create({
  // baseURL: "https://jk-xs.yemast.com:8007"
  // baseURL: "http://cqc-server-zuul.jsti-smart.cn"
  baseURL: "https://open.ys7.com/api/lapp"
});

Vue.prototype.$http = interceptLogin;

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js